module.exports = __webpack_public_path__ + "static/media/image-card-7.0c4847b2.png";